<template>
  <v-dialog :value="value" @input="(v) => $emit('input', v)" max-width="500">
    <v-card v-if="value" class="overflow-hidden" color="neutral700">
      <SizeBox height="8" />
      <div class="d-flex justify-end">
        <v-avatar
          size="24"
          @click="$emit('input', false)"
          class="cursor-pointer"
        >
          <img :src="require(`@/assets/icons/close.svg`)" />
        </v-avatar>
        <SizeBox width="8" />
      </div>
      <v-card-title class="flex-center pt-1">
        {{ $t('SPACE.EDIT.WORD.SHARE_LINK') }}
      </v-card-title>
      <SizeBox height="8" />
      <v-card-text class="flex-center flex-column">
        <!-- 連結產生成功！ -->
        {{ $t('SPACE.EDIT.TOAST.SUCCESS.LINK_GENERATE_SUCCESSFULLY') }}
        <SizeBox height="12" />
        <v-text-field
          :value="URL"
          background-color="neutral800"
          class="w90p input-copy"
          hide-details
          readonly
          outlined
          dense
        >
        <template v-slot:append>        
          <v-icon class="icon-copy" @click="copy">mdi-content-copy</v-icon> 
        </template>
      </v-text-field>
        <SizeBox height="24" />
        <div class="d-flex">
          <v-btn color="primary" depressed :href="URL" target="_blank">
            <span class="white--text">
              <v-icon>mdi-open-in-new</v-icon>
              <!-- 前往展覽 -->
              {{ $t('SPACE.WORD.GO_TO_EXH') }}
            </span>
          </v-btn>
        </div>

        <SizeBox height="32" />
        <!-- <div class="d-flex">
          <v-btn fab depressed color="#1DA1F3" width="64" height="64">
            <v-avatar :size="32">
              <img :src="require(`@/assets/icons/twitter.svg`)" />
            </v-avatar>
          </v-btn>
          <SizeBox width="20" />
          <v-btn fab depressed color="#5865F2" width="64" height="64">
            <v-avatar :size="32">
              <img :src="require(`@/assets/icons/discord.svg`)" />
            </v-avatar>
          </v-btn>
          <SizeBox width="20" />
          <v-btn fab depressed color="#1877F2" width="64" height="64">
            <v-avatar :size="32">
              <img :src="require(`@/assets/icons/facebook-f.svg`)" />
            </v-avatar>
          </v-btn>
          <SizeBox width="20" />
          <v-btn fab depressed color="#00C200" width="64" height="64">
            <v-avatar :size="32">
              <img :src="require(`@/assets/icons/line.svg`)" />
            </v-avatar>
          </v-btn>
        </div>
        <SizeBox height="44" /> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expoData: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data() {
    return {
      isCopyCooldown: false
    };
  },

  computed: {
    URL() {
      return `${this.$frontPageURL}/${this.expoData.alias}`;
    }
  },

  methods: {
    copy() {
      if (this.isCopyCooldown) return;

      const timeout = 2000;

      navigator.clipboard.writeText(this.URL);

      this.isCopyCooldown = true;
      this.$toast(this.$t('SPACE.TOAST.SUCCESS.COPIED'), {
        timeout,
      });

      setTimeout(() => {
        this.isCopyCooldown = false;
      }, timeout);
    }
  }
};
</script>

<style lang="scss" scoped>
.icon-copy {
  cursor: pointer;
  &:hover {
    color: var(--color-primary500);
  }
}
</style>